/**
 * useUtilisation — owns GET /api/v1/utilisation/breakdown (the Utilisation numerator
 * drill). TanStack Query + the carried AuthContext token (CD-7: hooks fetch). The 200
 * body is a typed union: UtilisationBreakdown OR an honest Refusal (Group is a simple
 * average — non-additive); a 422 arrives as the ApiError the panel renders verbatim.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useAuth } from '../contexts/AuthContext'
import type { Site, UtilisationResult } from '../types/metrics'
import { ApiError, fetchApi } from './apiFetch'

export function useUtilisation(
  site: Site,
  period: string
): UseQueryResult<UtilisationResult, ApiError> {
  const { token } = useAuth()
  const params = new URLSearchParams({ site, period })
  return useQuery<UtilisationResult, ApiError>({
    queryKey: ['utilisation', site, period],
    queryFn: () => fetchApi<UtilisationResult>(`utilisation/breakdown?${params.toString()}`, token),
    enabled: token !== null && period !== '',
  })
}
